/*
  The collection pages (round 39): what moves on them. Loaded by sections/main-collection-product-grid.liquid.
  - the silent film of the opening loads only after the page, only the one the screen shows (wide or upright),
    plays while it is on screen, and never for visitors who save data or ask for reduced motion;
  - the campaign's photographs follow one another every seven seconds (the later ones load after the first);
  - every drawn name (the opening's, the next chapter's, the collections') is cropped to its ink, so each stands at
    one optical height whatever padding its file carries;
  - the film with sound plays over the page, made only when asked for and taken away when closed;
  - the cards and the campaign's moments rise into place as they come into view, once; cards the filters bring in
    later are simply shown.
*/
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  /* round 45: a slow connection (3G or less, or data saver) keeps the still; the film would take half a minute */
  var saving = conn.saveData || /(^|-)2g$|^3g$/.test(conn.effectiveType || '');
  var hasIO = 'IntersectionObserver' in window;

  /* ---- the silent film ---- */
  function film(hero) {
    var videos = Array.prototype.slice.call(hero.querySelectorAll('video[data-vrc-film]'));
    if (!videos.length || reduce || saving) return;
    var v = null;
    videos.forEach(function (x) { if (!v && window.getComputedStyle(x).display !== 'none') v = x; });
    if (!v) return;
    var started = false, onScreen = true, pageReady = document.readyState === 'complete';
    var play = function () { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    var start = function () {
      if (started || !pageReady || !onScreen) return;
      started = true;
      v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
      v.src = v.getAttribute('data-src');
      play();
    };
    /* the film waits for the page to have loaded (round 45: the fallback for a load that never comes is 6 s, not
       2.5 s, so on a slow phone the film no longer competes with the page's own photographs) */
    if (!pageReady) window.addEventListener('load', function () { pageReady = true; window.setTimeout(start, 300); }, { once: true });
    window.setTimeout(function () { pageReady = true; start(); }, 6000);
    if (hasIO) {
      new IntersectionObserver(function (es) {
        onScreen = es[0].isIntersecting;
        if (!started) { start(); return; }
        if (onScreen) play(); else v.pause();
      }, { threshold: 0.05 }).observe(hero);
    }
    document.addEventListener('visibilitychange', function () { if (!document.hidden && started && onScreen) play(); });
  }

  /* ---- the campaign's photographs, one after another ---- */
  function frames(hero) {
    var box = hero.querySelector('[data-vrc-frames]');
    if (!box) return;
    var imgs = Array.prototype.slice.call(box.querySelectorAll('.vrc-frames__img'));
    if (imgs.length < 2) return;
    var hydrate = function () {
      imgs.forEach(function (im) {
        if (im.getAttribute('data-srcset')) { im.srcset = im.getAttribute('data-srcset'); im.removeAttribute('data-srcset'); }
        if (im.getAttribute('data-src')) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); }
      });
    };
    if (document.readyState === 'complete') window.setTimeout(hydrate, 400);
    else window.addEventListener('load', function () { window.setTimeout(hydrate, 400); }, { once: true });
    if (reduce) return;
    var i = 0, timer = 0, onScreen = true;
    var ready = function (im) { return im.complete && im.naturalWidth > 0 && !im.getAttribute('data-src'); };
    var step = function () {
      for (var k = 1; k < imgs.length; k++) {
        var n = (i + k) % imgs.length;
        if (ready(imgs[n])) {
          imgs[i].classList.remove('is-on');
          /* restart the slow drawing closer on the photograph coming in */
          imgs[n].style.animation = 'none'; void imgs[n].offsetWidth; imgs[n].style.animation = '';
          imgs[n].classList.add('is-on');
          i = n;
          return;
        }
      }
    };
    var run = function () { if (!timer && onScreen && !document.hidden) timer = window.setInterval(step, 7000); };
    var stop = function () { window.clearInterval(timer); timer = 0; };
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else run(); });
    if (hasIO) new IntersectionObserver(function (es) { onScreen = es[0].isIntersecting; if (onScreen) run(); else stop(); }, { threshold: 0.1 }).observe(hero);
    run();
  }

  /* ---- drawn names, cropped to their ink ---- */
  var inks = {};
  function ink(url, done) {
    var c = inks[url];
    if (c) { if (c.ready) done(c.v); else c.q.push(done); return; }
    c = inks[url] = { ready: false, v: null, q: [done] };
    var finish = function (v) { c.ready = true; c.v = v; c.q.forEach(function (f) { f(v); }); c.q = []; };
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () {
      try {
        if (!im.naturalWidth || !im.naturalHeight) { finish(null); return; }
        var W = 320, H = Math.max(1, Math.round(W * im.naturalHeight / im.naturalWidth));
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var g = cv.getContext('2d'); g.drawImage(im, 0, 0, W, H);
        var d = g.getImageData(0, 0, W, H).data;
        var x0 = W, y0 = H, x1 = -1, y1 = -1;
        for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) { if (d[(y * W + x) * 4 + 3] > 40) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; } }
        if (x1 < 0) { finish(null); return; }
        var fw = (x1 + 1 - x0) / W, fh = (y1 + 1 - y0) / H, fx = x0 / W, fy = y0 / H;
        finish({
          ar: (fw * im.naturalWidth) / (fh * im.naturalHeight),
          size: (100 / fw).toFixed(2) + '% ' + (100 / fh).toFixed(2) + '%',
          pos: (fw >= 0.999 ? 50 : fx / (1 - fw) * 100).toFixed(2) + '% ' + (fh >= 0.999 ? 50 : fy / (1 - fh) * 100).toFixed(2) + '%'
        });
      } catch (e) { finish(null); /* a file the canvas may not read: shown whole */ }
    };
    im.onerror = function () { finish(null); };
    im.src = url;
  }
  /* round 45: a drawn name on the first screen is measured at once; the others (the strip of names, the next
     chapter) as they come near, since reading a file on a canvas takes a moment better not spent while loading */
  function marks(root) {
    var near = hasIO ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { near.unobserve(e.target); measure(e.target); } });
    }, { rootMargin: '700px 0px 700px 0px' }) : null;
    root.querySelectorAll('[data-vrc-ink]').forEach(function (el) {
      if (el.dataset.vrcInked) return;
      if (near && el.getBoundingClientRect().top > window.innerHeight * 1.5) near.observe(el); else measure(el);
    });
  }
  function measure(el) {
    if (el.dataset.vrcInked) return;
    el.dataset.vrcInked = '1';
    ink(el.getAttribute('data-vrc-ink'), function (v) {
      if (!v) return;
      el.style.setProperty('--ink-ar', v.ar.toFixed(4));
      el.style.setProperty('--ink-size', v.size);
      el.style.setProperty('--ink-pos', v.pos);
      el.style.setProperty('--ink-boost', Math.min(1.42, Math.max(0.74, Math.sqrt(2.6 / v.ar))).toFixed(3));
      el.classList.add('is-measured');
    });
  }

  /* ---- the film with sound ---- */
  function watch(root) {
    var modal = document.querySelector('[data-vrc-film-modal]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-vrc-watch]'));
    if (!modal || !buttons.length) return;
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    var frame = modal.querySelector('.vrc-film-modal__frame');
    var title = modal.querySelector('.vrc-film-modal__title');
    var close = modal.querySelector('[data-vrc-film-close]');
    var from = null, timer = 0;
    var open = function (b) {
      var id = b.getAttribute('data-vrc-watch'), file = b.getAttribute('data-vrc-watch-file');
      if (!id && !file) return;
      window.clearTimeout(timer);
      from = b;
      title.textContent = b.getAttribute('data-vrc-watch-title') || '';
      while (frame.firstChild) frame.removeChild(frame.firstChild);
      if (id) {
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
        f.title = title.textContent || 'Film';
        f.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        frame.appendChild(f);
      } else {
        var v = document.createElement('video');
        v.src = file; v.controls = true; v.autoplay = true; v.playsInline = true;
        frame.appendChild(v);
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
      modal.hidden = false;
      document.documentElement.classList.add('vrc-film-open');
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { modal.classList.add('is-open'); }); });
      close.focus();
    };
    var shut = function () {
      if (modal.hidden) return;
      modal.classList.remove('is-open');
      document.documentElement.classList.remove('vrc-film-open');
      /* the player goes as the fade begins, so the sound stops at once */
      while (frame.firstChild) frame.removeChild(frame.firstChild);
      timer = window.setTimeout(function () { modal.hidden = true; }, reduce ? 0 : 500);
      if (from) from.focus();
    };
    buttons.forEach(function (b) { b.addEventListener('click', function () { open(b); }); });
    close.addEventListener('click', shut);
    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.classList.contains('vrc-film-modal__inner')) shut(); });
    document.addEventListener('keydown', function (e) { if ((e.key === 'Escape' || e.key === 'Esc') && !modal.hidden) shut(); });
    document.addEventListener('focusin', function (e) { if (!modal.hidden && modal.classList.contains('is-open') && !modal.contains(e.target)) close.focus(); });
  }

  /* ---- the cards and the campaign's moments rise into place ---- */
  function reveal(root) {
    if (reduce || !hasIO) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        e.target.classList.add('is-in');
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -4% 0px' });
    var arm = function (els) {
      var top = null, d = 0;
      els.forEach(function (el) {
        if (el.classList.contains('is-armed')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.92) return;
        if (top === null || Math.abs(r.top - top) > 40) { top = r.top; d = 0; } else d++;
        el.style.setProperty('--d', Math.min(d, 3));
        el.classList.add('is-armed');
        io.observe(el);
      });
    };
    arm(Array.prototype.slice.call(root.querySelectorAll('#product-grid > li, [data-vrc-reveal]')));
  }

  function init(root) {
    var vrc = root.matches && root.matches('[data-vrc]') ? root : root.querySelector('[data-vrc]');
    if (!vrc || vrc.dataset.vrcReady) return;
    vrc.dataset.vrcReady = '1';
    var hero = vrc.querySelector('[data-vrc-hero]');
    if (hero) { film(hero); frames(hero); }
    watch(vrc);
    if ('requestIdleCallback' in window) window.requestIdleCallback(function () { marks(vrc); }, { timeout: 1200 });
    else window.setTimeout(function () { marks(vrc); }, 300);
    reveal(vrc);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
